import { useSelectRoleFieldQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery() {
  const tuple = useSelectRoleFieldQuery();

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.roles.map((node) => ({
        id: node.id,
        name: node.id,
        displayName: node.displayName
      })) ?? [];
      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
